<template>
  <q-dialog full-height maximized class="fullscreen"
    ref="concessionContractTariffModal"
    @show="onShowHandler"
    @hide="onHideHandler"
  >
    <q-layout
      view="Lhh lpR fff"
      container
      class="bg-white modal-large concessionContractTariffContainer"
    >
      <q-header class="bg-primary">
        <q-toolbar>
          <q-toolbar-title>
            <q-icon name="library_add" size="25px" class="q-pr-sm" />
            {{ $gettext(computedTitle) }}
          </q-toolbar-title>
          <q-btn flat @click="hide">
            <q-icon name="cancel" size="2.5em"/>
          </q-btn>
        </q-toolbar>
      </q-header>

      <jt-dynamic-form
        v-if="renderForm"
        ref="compositionForm"
        :inputs="form.inputs"
        :interface="form.nmInterface"
        :relacionamentos="form.relacionamentos"
        :model="form.dadosForm"
        form-class="form"
        class="q-pa-lg formContainer concessionContractTariffForms"
        @search-found="selections"
      />

      <section
        class="row justify-center full-width q-gutter-md q-pa-lg sectionConcessionContractTariff"
      >
        <div
          v-for="(button, index) in form.buttons"
          :key="index"
          class="col-2 buttonsConcessionContractTariff"
        >
          <q-btn
            class="full-width"
            color="positive"
            :name="button.name"
            @click="onFormButtonClickHandler(button)"
            >{{ button.label }}
          </q-btn>
        </div>
      </section>
    </q-layout>
  </q-dialog>
</template>

<script>
import { Component, Vue, Watch } from 'vue-property-decorator'
import { JtDynamicForm, JtCompositionFormModal } from 'jtech-webcomps'
import { repository } from 'jtech'
import {
  QDialog,
  QLayout,
  QIcon,
  QToolbar,
  QToolbarTitle,
  QHeader,
  QBtn,
  QTab,
  QTabPanel,
  QTabPanels
} from 'quasar'

@Component({
  mixins: [JtCompositionFormModal],
  components: {
    JtDynamicForm,
    QDialog,
    QLayout,
    QIcon,
    QToolbar,
    QHeader,
    QToolbarTitle,
    QBtn,
    QTab,
    QTabPanel,
    QTabPanels
  },
  props: {
    form: { type: Object, required: true },
    composicaos: { type: Array, required: true },
    nrLinhaSelecionada: Number,
    flComposicaoAlteracao: Boolean
  }
})
class ConcessionContractTariff extends Vue {
    renderForm = false;
    formModel = {};
    nmIntefaceConcessionContractTariff = 'concessionContractTariff.searchContractTariffByContractAndType';
    async show () {
      this.renderForm = true
      this.formModel = this.form.dadosForm
      this.$refs.concessionContractTariffModal.show()
      await this.updateConcessionContractTariffDependentOptions()
    }

    hide () {
      this.$refs.concessionContractTariffModal.hide()
      this.form = { dadosForm: {}, inputs: [], buttons: [], nmInterface: '', relacionamentos: {} }
    }

    async selections (data) {
      if (data && data.address && data.address.idField) {
        const param = { id: data.address.idField }
        const { registros } = await repository.resolveDatatableModel('address.pesquisarSelecao', param)
        this.$nextTick(() => {
          this.form.dadosForm.address = data.address.idField
          this.$set(this.form.dadosForm, 'zipCode', registros[0].zipCode)
          this.$set(this.form.dadosForm, 'neighborhood', registros[0].neighborhood)
          this.$set(this.form.dadosForm, 'city', registros[0].city)
          this.$set(this.form.dadosForm, 'state', registros[0].state)
          this.$set(this.form.dadosForm, 'country', registros[0].country)
        })
      }
    }

    @Watch('form.dadosForm.tariffPeriodType')
    async onTariffPeriodTypeChanged (newVal, oldVal) {
      if (oldVal != null && newVal != null) {
        this.form.dadosForm.concessionContractTariffDependent = null
      }
      if (newVal === 50440002) {
        this.$set(this.form.dadosForm, 'carneLayoutType', 50450002)
      }
      await this.updateConcessionContractTariffDependentOptions()
    }

    async updateConcessionContractTariffDependentOptions () {
      if (this.form.dadosForm.tariffPeriodType) {
        const { registros } = await repository.resolveLogic(this.nmIntefaceConcessionContractTariff, {
          tariffPeriodType: this.form.dadosForm.tariffPeriodType,
          concessionContract: this.form.dadosForm.concessionContract,
          id: this.form.dadosForm.id
        })
        this.form.relacionamentos.concessionContractTariffDependent = this.convertDataToComboField(registros)
      } else {
        this.form.relacionamentos.concessionContractTariffDependent = []
        console.log('entrou no else')
        this.form.dadosForm.carneLayoutType = undefined
      }
    }

    convertDataToComboField (registers) {
      return registers.map(item => ({
        label: item.description,
        value: item.id
      }))
    }

    setEditable (object) {
      if (object && object.id) object.flAlterado = 'S'
    }

    onFormButtonClickHandler (button) {
      if (button.name === 'btSalvarComposicao') {
        this.__saveButtonHandler({ button, fields: this.formModel })
      } else if (button.name === 'btFecharComposicao') this.hide()
    }
}
export default ConcessionContractTariff
</script>

<style lang="stylus" scoped>
@import '~quasar-variables';

.concessionContractTariffContainer {
  border-radius: 0px !important;
  display: flex !important;
  flex-direction: column !important;
  height: 100vh !important;
  min-height: 0 !important;
}

.concessionContractTariffForms {
  display: flex !important;
  flex-direction: column !important;
  flex: 1 1 auto !important;
  min-height: 0 !important;
  #scroll-area {
    height: 100% !important;
    min-height: 0 !important;
    max-height: 100% !important;
    overflow-y: auto !important;
    .q-scrollarea__content{ position: relative !important; min-height: 0 !important; }
  }
}

.sectionConcessionContractTariff {
  .buttonsConcessionContractTariff:first-child { .q-btn { background: #A9B9C2 !important; color: black; } }
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  padding-top: 8px !important;
  padding-bottom: 16px !important;
  flex-shrink: 0 !important;
}

.concessionContractTariffContainer > .q-header { flex: 0 0 auto !important; }

@media only screen and (max-height: 765px) {
  .concessionContractTariffForms { #scroll-area { height: calc(65vh - 12px) !important; } }
}
</style>

<style>
/* Global fallback for modal scrollareas and tables to avoid overflow/cut fields */
.concessionContractTariffContainer .q-scrollarea__container,
.concessionContractTariffContainer .q-scrollarea__content,
.concessionContractTariffContainer .q-scrollarea__content.absolute {
  width: 100% !important;
  max-width: 100% !important;
  box-sizing: border-box !important;
  position: relative !important;
  left: auto !important;
  right: auto !important;
  top: auto !important;
  bottom: auto !important;
  transform: none !important;
  overflow-x: hidden !important;
}

/* Ensure scrollareas and their inner nodes stretch to fill modal height */
.concessionContractTariffContainer,
.concessionContractTariffContainer .q-layout,
.concessionContractTariffContainer .q-layout .q-scrollarea,
.concessionContractTariffContainer .q-scrollarea__container,
.concessionContractTariffContainer .q-scrollarea__content,
.concessionContractTariffContainer #scroll-area {
  min-height: 80vh !important;
  max-height: 100% !important;
}

.concessionContractTariffContainer .q-layout .absolute-full {
  height: 100% !important;
}

.concessionContractTariffContainer .q-table__middle,
.concessionContractTariffContainer .q-table__container { width: 100% !important; max-width: 100% !important; overflow-x: auto !important; }

.concessionContractTariffContainer .q-table th,
.concessionContractTariffContainer .q-table td,
.concessionContractTariffContainer .q-td { min-width: 0 !important; max-width: 100% !important; white-space: nowrap !important; overflow: hidden !important; text-overflow: ellipsis !important; }

.concessionContractTariffContainer .jt-composition-container #jt-composition .jt-datatable {
  min-width: 0 !important;
  width: 100% !important;
  max-width: 100% !important;
}
</style>
